import React from "react";
import LifestyleThreeZoneTrendChart, {
  type ExerciseChartDataPoint,
  getExerciseColor,
} from "../../../HealthChart/components/LifestyleThreeZoneTrendChart";

export type { ExerciseChartDataPoint };
export { getExerciseColor };

export interface ExerciseChartProps {
  data: ExerciseChartDataPoint[];
}

const ExerciseChart: React.FC<ExerciseChartProps> = ({ data }) => (
  <LifestyleThreeZoneTrendChart variant="exercise" data={data} />
);

export default ExerciseChart;
